import { render, staticRenderFns } from "./withdrawalReview.vue?vue&type=template&id=4e3d2078&scoped=true"
import script from "./withdrawalReview.vue?vue&type=script&lang=js"
export * from "./withdrawalReview.vue?vue&type=script&lang=js"
import style0 from "./withdrawalReview.vue?vue&type=style&index=0&id=4e3d2078&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3d2078",
  null
  
)

export default component.exports